export default function PostContentEdit() {
	return (
		<p>
			{
				'Welcome to WordPress and the wonderful world of blocks. This content represents how a post would look when editing block templates.'
			}
		</p>
	);
}
